import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Nhận link dán sẵn qua `?link=` cho các trang Mua sắm hoàn tiền (Shopee/Lazada/TikTok).
 *
 * Nơi gọi: block "ÁP DỤNG CHO" của đợt thưởng, thông báo đẩy giảm giá, link chia sẻ…
 * Trang tự tra sản phẩm luôn, user không phải dán tay.
 *
 * Gộp về một chỗ vì cả 3 trang cần y hệt — chép 3 bản thì thêm sàn hoặc sửa hành vi
 * là phải nhớ sửa 3 nơi.
 *
 * `rewardNote` đi kèm để thẻ sản phẩm nhắc "đang có thưởng thêm". Nó bám theo ĐÚNG
 * link được truyền vào: user tra sản phẩm khác trên cùng trang thì note biến mất —
 * hiện note cho sản phẩm không thuộc đợt là hứa hão về TIỀN, không được phép.
 *
 * @param {string} currentTerm từ khoá/link trang đang tra (để đối chiếu)
 * @returns {{initialLink: string, rewardNote: string}} rewardNote rỗng khi đã đổi sản phẩm
 */
export function useSharedLinkParam(currentTerm) {
    const [searchParams, setSearchParams] = useSearchParams();
    // Đọc MỘT lần lúc mount rồi xoá param — refresh không tra lại, và URL sạch.
    const [shared] = useState(() => ({
        link: searchParams.get("link") || "",
        note: searchParams.get("rewardNote") || "",
    }));

    useEffect(() => {
        if (shared.link || shared.note) setSearchParams({}, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        initialLink: shared.link,
        rewardNote: shared.link && currentTerm === shared.link ? shared.note : "",
    };
}

export default useSharedLinkParam;
